const NullValues = new Set<unknown>([undefined, null, ""])

export const AlmostNullQ = (v: unknown) => NullValues.has(v)
